import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { CmsserviceService } from '../../../common-cms-service/cmsservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

declare var $: any;

@Component({
  selector: "app-elev-plus-tests",
  templateUrl: "./elev-plus-tests.component.html",
  styleUrls: ["./elev-plus-tests.component.css"],
  standalone: false
})
export class ElevPlusTestsComponent implements OnInit, OnDestroy {

  title = '11Plus Mock Test';
  slug: any;

  // ── Toolbar model ──────────────────────────────────────────
  filters: any = {
    categoryId: null, pattern: null, mode: null,
    month: null, center: null, search: ''
  };

  // ── Toolbar options ────────────────────────────────────────
  courses: any[] = [];
  categories: any[] = [];
  patternTypes: any[] = [];
  types: any[] = [];

  months = [
    { label: 'January', value: 1 },   { label: 'February', value: 2 },
    { label: 'March', value: 3 },     { label: 'April', value: 4 },
    { label: 'May', value: 5 },       { label: 'June', value: 6 },
    { label: 'July', value: 7 },      { label: 'August', value: 8 },
    { label: 'September', value: 9 }, { label: 'October', value: 10 },
    { label: 'November', value: 11 }, { label: 'December', value: 12 },
  ];
  centers: string[] = [];

  // ── Data ───────────────────────────────────────────────────
  testList: any[] = [];
  private allResults: any[] = [];

  // ── State ──────────────────────────────────────────────────
  ngUnsubscribe = new Subject<void>();
  catId = 0;
  catData: any;
  first = true;
  page = 0;
  locationName: any = '';
  openFaq: number = -1;

  private preselectCategoryId: number | null = null;
  private shouldAutoScroll = false;

  // ── Static centre cards ────────────────────────────────────
  aviableCenters = [
    { name: 'Essex', exams: 'CSSE & CCHS (FSCE)', locations: 'Chelmsford | Southend | Basildon | Ilford', image: 'assets/images/essex-public-school.jpg' },
    { name: 'Kent', exams: 'GL Kent & GL Bexley', locations: 'Bexley Test Centres', image: 'assets/images/kent-school.png' },
    { name: 'Redbridge', exams: 'GL Kent & GL Bexley', locations: 'Ilford Centre', image: 'assets/images/redbridge-school.jpg' },
    { name: 'Buckinghamshire', exams: 'GL Kent & GL Bexley', locations: 'Amersham | Milton Keynes Centres', image: 'assets/images/buckshire-school.jpeg' },
    { name: 'Harrow', exams: 'GL QE Boys, GL HBS Girls, GL Bucks', locations: 'Harrow Centre', image: 'assets/images/harrow-school.jpg' }
  ];

  // ── Static page content ────────────────────────────────────
  benefits: string[] = [
    'Real exam-style papers under timed conditions',
    'Multi-centre benchmarking with 150–250 students',
    'Detailed Result Analysis Report (RAR)',
    'Exam-board-specific formats (GL, CSSE, FSCE)',
    'Proven pathway: Topic Tests → Sprints → Full Mocks',
    'Develop focus, stamina and exam confidence'
  ];

  features: any[] = [
    {
      title: 'Cohort Performance Report (RAR)',
      text: 'Consolidated Result Analysis across all centres — standard score, rank and percentile benchmarked against the full cohort.',
      icon: '<svg fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24" width="20" height="20"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path></svg>'
    },
    {
      title: 'Expert Doubt-Clearing Sessions',
      text: 'One-on-one time with experienced 11+ teachers after every test to go through mistakes.',
      icon: '<svg fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24" width="20" height="20"><path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path></svg>'
    },
    {
      title: 'True Exam Conditions',
      text: 'Timed, invigilated sittings that mirror the real 11+ exam day experience.',
      icon: '<svg fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24" width="20" height="20"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>'
    },
    {
      title: 'Personalised Feedback',
      text: 'Tailored guidance and clear recommendations for specific areas to improve.',
      icon: '<svg fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24" width="20" height="20"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>'
    },
    {
      title: 'Take-Home Review Pack',
      text: 'Test papers and full answer keys to take home for continued revision and self-study.',
      icon: '<svg fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24" width="20" height="20"><path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>'
    },
    {
      title: 'Ongoing Consultation',
      text: 'Continuous support throughout the year to track progress and close learning gaps.',
      icon: '<svg fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24" width="20" height="20"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>'
    }
  ];

  testimonials: any[] = [
    {
      name: 'Jaya Rani',
      text: 'My son did Sehyog Mock Test — very helpful to know which areas he was lacking. The result analysis gives a clear understanding of what to improve. Sehyog also provided guidance on CAF forms and clarified all doubts. Thank you!'
    },
    {
      name: 'Harita Nagula',
      text: 'Sehyog Mocks really helped my twins secure a place at ICHS. The mock exams gave them confidence and helped follow timing and instructions. I would recommend to anyone preparing for the real exam.'
    },
    {
      name: 'Mini Dagar',
      text: 'With the detailed results every week, we knew which area to work on. Topic tests were great revision. The whole team helped my son secure a safe place at his school of choice. Big thanks!'
    }
  ];

  faqs: any[] = [
    {
      q: 'How do I book my 11+ Mock Test?',
      a: 'Use the filters in the Schedule section to find a session by centre, date and exam board, then click the gold "Book Now" button on any session card. The booking page takes under 60 seconds to complete.'
    },
    {
      q: 'Are these tests online or face-to-face?',
      a: 'We offer both. Use the Mode filter to show only Online or Face-to-Face sessions. Online sessions are available from the start date shown; face-to-face sessions take place at the specific centre listed on the card.'
    },
    {
      q: 'Which exam boards do you cover?',
      a: 'We cover GL, CSSE, FSCE, SET and ISEB — all the major UK 11+ exam boards. Use the Exam Board filter in the schedule to narrow results to your specific board.'
    },
    {
      q: 'What is the difference between Topic Test, Sprint and Mock Test?',
      a: 'Topic Tests (Oct–Feb) target specific subjects to build knowledge. Sprints (Oct–Feb) are speed drills to improve accuracy under time pressure. Full Mock Tests (Mar–Sep) are complete exam-length papers under real conditions. Recommended path: Topic Tests → Sprints → Mocks.'
    },
    {
      q: 'What is included in every mock exam booking?',
      a: 'Every booking includes: a cohort Result Analysis Report (RAR), expert doubt-clearing session, test papers and answer keys to take home, personalised feedback and ongoing consultation support throughout the year.'
    }
  ];

  // ── Constructor ────────────────────────────────────────────
  constructor(
    private router: ActivatedRoute,
    private titleService: Title,
    private categoryProduct: CmsserviceService,
    private route: Router,
    private ref: ChangeDetectorRef
  ) {}

  // ── Lifecycle ──────────────────────────────────────────────
  ngOnInit(): void {
    this.titleService.setTitle(this.title);

    // Query param: preselect category and/or auto-scroll
    // Query param: preselect category and/or auto-scroll
this.router.queryParams.subscribe((params: any) => {
  if (params['category']) {
    const cid = Number(params['category']);

    if (!isNaN(cid)) {
      this.preselectCategoryId = cid;
      this.filters.categoryId = cid;
    }
  }

  if (params['scroll'] === 'calendar-section') {
    this.shouldAutoScroll = true;
  }
});

// Legacy location param
this.router.queryParams.subscribe((params: any) => {
  this.locationName = params.location;

  const ul = $(".test-card-listing-body");
  const li = ul.find(".test-card");

  if (this.locationName && this.testList && this.testList.length) {
    this.locationSpecificList(this.locationName);
  } else if (!this.locationName && li && li.length) {
    this.locationSpecificList('');
  }
});

    this.loadMasterFiltersAndRender();
    this.setupUiHandlers();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  // ── UI handlers (jQuery legacy kept intact) ────────────────
  private setupUiHandlers() {
    var self = this;
    var width = $(window).width();

    if (width < 900) {
      $('.filter-box.filter-tab').eq(0).find('h4').addClass('act');
      $('.filter-box.filter-tab h4').click((e: any) => {
  $('.filter-box h4').removeClass('act');

  $(e.currentTarget).addClass('act');

  $('.filter-box ul').removeClass('act');

  $(e.currentTarget).parent().find('ul').addClass('act');
});
      $('.open-filter-panel').click(function() { $('#filter-fixed-02').addClass('open'); });
      $('.close-filter-panel').click(function() { $('#filter-fixed-02').removeClass('open'); });
      $('.open-sort-panel').click(function() { $('.sort-panel').addClass('open'); });
      $('.sort-panel .overlay').click(function() { $('.sort-panel').removeClass('open'); });
      $(window).scroll(function() {
        if ($(window).scrollTop() + $(window).height() == $(document).height()) {
          $('.filter-action').hide(); $('.action-btns').hide(); $('.cart-mobile-fixed-btn').hide();
        } else {
          $('.filter-action').show(); $('.action-btns').show(); $('.cart-mobile-fixed-btn').show();
        }
      });
    }

    $('body').on('click', '.tag-ul li', function(e: any) {
      var tagId = $(e.currentTarget).attr('id');
      var tagClass = $(e.currentTarget).attr('class');
      if (tagClass == 'tag-category') $('[name="category[]"][value="' + tagId + '"]').prop('checked', false);
      if (tagClass == 'tag-course')   $('[name="course[]"][value="' + tagId + '"]').prop('checked', false);
      if (tagClass == 'tag-type')     $('[name="type[]"][value="' + tagId + '"]').prop('checked', false);
      $(e.currentTarget).remove();
      self.applyClientFilters();
    });

    $('body').on('change', '[name="sort"]', function(e: any) {
      var checked = $(e.currentTarget).val();
      $('body').find('[name="release"][value="' + checked + '"]').prop('checked', true);
      self.setFilter();
    });

    $('body').on('keyup', '.filter-search-filter-input', function(e: any) {
      var q = ($(e.currentTarget).val() || '').toString().trim().toUpperCase();
      var ul = $('.test-card-listing-body');
      var li = ul.find('.test-card');
      for (var i = 0; i < li.length; i++) {
        var ftestVal   = li[i].getElementsByClassName('f-test-name')[0].textContent || '';
        var fcatVal    = li[i].getElementsByClassName('f-category-name')[0].textContent || '';
        var fcourseVal = li[i].getElementsByClassName('f-course-name')[0].textContent || '';
        var ftypeVal   = li[i].getElementsByClassName('f-type-name')[0].textContent || '';
        var flocVal    = li[i].getElementsByClassName('f-location-name')[0].textContent || '';
        var ffeeVal    = li[i].getElementsByClassName('f-fees')[0].textContent || '';
        if (
          ftestVal.toUpperCase().indexOf(q) > -1 || fcatVal.toUpperCase().indexOf(q) > -1 ||
          fcourseVal.toUpperCase().indexOf(q) > -1 || ftypeVal.toUpperCase().indexOf(q) > -1 ||
          flocVal.toUpperCase().indexOf(q) > -1 || ffeeVal.toUpperCase().indexOf(q) > -1
        ) {
          (li[i] as any).style.display = '';
        } else {
          (li[i] as any).style.display = 'none';
        }
      }
    });
  }

  // ── Load filter options then all test pages ────────────────
  private loadMasterFiltersAndRender() {
    var self = this;
    $('.loader-bg').fadeIn();
    this.categoryProduct.getTestFilters()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(function(res: any) {
        var data = (res && res.data) ? res.data : {};
        var allCategories = data.category ? data.category : [];
        var allTypes      = data.type ? data.type : [];
        self.courses  = data.course ? data.course : [];
        self.types    = allTypes;

        self.categories = allCategories.filter(function(c: any) {
          return c.category_id === 16 || c.category_id === 19 || c.category_id === 39;
        });

        var allowedPatternNames = [
          'GL', 'CEM', 'CSSE', 'FSCE', 'SET',
          'GL Redbridge', 'GL Kent', 'GLQE Barnet', 'GL Bucks', 'GL Bexley', 'GL HBS'
        ];
        self.patternTypes = allTypes.filter(function(t: any) {
          return allowedPatternNames.indexOf(t.type) !== -1;
        });

        self.render();
      }, function(err: any) {
        console.error('getTestFilters error', err);
        self.render();
      });
  }

  // ── Public filter methods ──────────────────────────────────
  setFilter() {
    this.applyClientFilters();
  }

  setFilterRes() {
    this.setFilter();
  }

  /**
   * Set mode filter from the visible toggle buttons (Online / Face to Face / null = all)
   */
  setMode(mode: string | null) {
    this.filters.mode = mode;
    this.applyClientFilters();
  }

  resetAllFilters() {
    $('.filter-search-filter-input').val('');
    if ($('form[name="filterBox"]').length)    ($('form[name="filterBox"]')[0] as HTMLFormElement).reset();
    if ($('form[name="filterBoxRes"]').length) ($('form[name="filterBoxRes"]')[0] as HTMLFormElement).reset();
    $('[type="checkbox"]').prop('checked', false);
    this.filters = { categoryId: null, pattern: null, mode: null, month: null, center: null, search: '' };
    this.applyClientFilters();
  }

  /**
   * Called from the visual type cards — sets categoryId and scrolls to calendar.
   * type: 'mock' → category 16, 'topic' → 19, 'sprint' → 39
   */
  filterByType(type: string) {
    this.resetAllFilters();
    var idMap: any = { mock: 16, topic: 19, sprint: 39 };
    var cid = idMap[type];
    if (cid) {
      this.filters.categoryId = cid;
      this.applyClientFilters();
    }
  }

  /**
   * Called from the centre cards — sets center filter and scrolls to calendar.
   */
  filterByCentre(centre: string) {
    this.filters.center = centre;
    this.applyClientFilters();
    var self = this;
    setTimeout(function() { self.scrollToCalendar(); }, 100);
  }

  // ── Load all pages recursively ─────────────────────────────
  render() {
    var self = this;
    $('.load-button').css('display', 'none');
    $('.loader-bg').fadeIn();

    var base: any = this.buildBasePayload();
    this.allResults = [];
    var maxPages = 50;
    var pagesFetched = 0;

    var finalizeLoad = function() {
      console.log('Loaded total ' + self.allResults.length + ' tests across ' + pagesFetched + ' pages');
      self.centers = self.buildCenters(self.allResults);
      if (self.preselectCategoryId != null) {
        self.filters.categoryId = self.preselectCategoryId;
      }
      self.applyClientFilters();
      if (self.shouldAutoScroll) {
        setTimeout(function() { self.scrollToCalendar(); }, 200);
      }
      $('.loader-bg').fadeOut();
      self.ref.detectChanges();
    };

    var fetchPage = function(pageNum: number) {
      if (pageNum > maxPages) {
        console.warn('Reached max page fetch limit', maxPages);
        finalizeLoad();
        return;
      }
      pagesFetched++;
      var formData = Object.assign({}, base, { page: pageNum });

      self.categoryProduct.getTestList(formData)
        .pipe(takeUntil(self.ngUnsubscribe))
        .subscribe(function(res: any) {
          var chunk = (res && res.data) ? res.data : [];
          if (chunk.length === 0) { finalizeLoad(); return; }
          self.allResults = self.allResults.concat(chunk);
          var extra = (res && res.extra && typeof res.extra.extraCount === 'number') ? res.extra.extraCount : null;
          if (extra !== null) {
            if (extra > 0) { fetchPage(pageNum + 1); } else { finalizeLoad(); }
          } else {
            fetchPage(pageNum + 1);
          }
        }, function(err: any) {
          console.error('Error fetching tests', err);
          finalizeLoad();
        });
    };

    fetchPage(1);
  }

  // ── Build API payload ──────────────────────────────────────
  private buildBasePayload() {
    var width = $(window).width();
    var data: any[] = [];
    if (width < 900) {
      $('#filter-fixed-02').removeClass('open');
      if ($('form[name="filterBoxRes"]').length) data = $('form[name="filterBoxRes"]').serializeArray();
    } else {
      if ($('form[name="filterBox"]').length) data = $('form[name="filterBox"]').serializeArray();
    }

    var formData: any = {};
    var course: any[] = [];
    var category: any[] = [];
    var type: any[] = [];

    for (var i = 0; i < data.length; i++) {
      if (data[i]['name'] == 'course[]')        { course.push(data[i]['value']); }
      else if (data[i]['name'] == 'category[]') { category.push(data[i]['value']); }
      else if (data[i]['name'] == 'type[]')     { type.push(data[i]['value']); }
      else                                       { formData[data[i]['name']] = data[i]['value']; }
    }

    if (this.first && this.catId) { category.push(String(this.catId)); }

    if (!('release' in formData))   formData['release'] = 'new';
    if (!('exam_type' in formData)) formData['exam_type'] = 'both';
    if (!('search' in formData))    formData['search'] = '';

    if (this.filters && this.filters.pattern != null) {
      var tid = String(this.filters.pattern);
      if (type.indexOf(tid) === -1) type.push(tid);
    }

    if (this.filters && this.filters.mode) {
      var v = this.filters.mode;
      formData['exam_type'] = (v === 'Online Session') ? 'online'
                            : (v === 'Classroom Session') ? 'classroom'
                            : 'both';
    }

    if (this.filters && this.filters.month != null) formData['month'] = this.filters.month;
    if (this.filters && this.filters.center)         formData['location'] = this.filters.center;

    formData['course']   = course;
    formData['category'] = category;
    formData['type']     = type;

    const user = Number(localStorage.getItem('userid') || 0);

formData['user_id'] = user;

    return formData;
  }

  // ── 11+ restriction ────────────────────────────────────────
  private isElevenPlus(t: any): boolean {
    if (!t) return false;
    var cid = Number(t.category_id);
    var courseName = (t.course || '').toString().toLowerCase();
    var courseId   = Number(t.course_id);
    var name       = (t.test_name || '').toString().toLowerCase();
    var ELEVENPLUS_CATEGORY_IDS = [16, 19, 39, 28, 29, 30, 31, 32, 33];
    return (
      courseName === '11plus' || courseId === 1 ||
      ELEVENPLUS_CATEGORY_IDS.indexOf(cid) !== -1 ||
      name.indexOf('11+') !== -1 || name.indexOf('11plus') !== -1
    );
  }

  // ── Date parsing & sorting ─────────────────────────────────
  private monthMap: any = { JAN:0,FEB:1,MAR:2,APR:3,MAY:4,JUN:5,JUL:6,AUG:7,SEP:8,OCT:9,NOV:10,DEC:11 };
  private fullMonthMap: any = { JANUARY:0,FEBRUARY:1,MARCH:2,APRIL:3,MAY:4,JUNE:5,JULY:6,AUGUST:7,SEPTEMBER:8,OCTOBER:9,NOVEMBER:10,DECEMBER:11 };

  private parseDateString(s: string): number | null {
    if (!s) return null;
    var str = s.trim();
    var m = str.match(/(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})/);
    if (m) {
      var d = parseInt(m[1], 10), mo = parseInt(m[2], 10) - 1, y = parseInt(m[3], 10);
      if (y < 100) y += 2000;
      return Date.UTC(y, mo, d);
    }
    m = str.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (m) { return Date.UTC(parseInt(m[1],10), parseInt(m[2],10)-1, parseInt(m[3],10)); }
    m = str.match(/(?:from\s+)?(?:mon|tue|wed|thu|fri|sat|sun)?\s*([A-Za-z]+)\s+(\d{1,2})(?:st|nd|rd|th)?(?:,?\s*(\d{4}))?/i);
    if (m) {
      var monName = m[1].toUpperCase();
      var dd = parseInt(m[2], 10);
      var yy = m[3] ? parseInt(m[3], 10) : (new Date()).getFullYear();
      var monIdx = this.fullMonthMap[monName];
      if (monIdx == null) monIdx = this.monthMap[monName.substring(0,3)];
      if (monIdx != null) return Date.UTC(yy, monIdx, dd);
    }
    m = str.match(/(\d{1,2})\s+([A-Za-z]{3,})\s+(\d{4})/);
    if (m) {
      var d2 = parseInt(m[1],10), y2 = parseInt(m[3],10);
      var mn = m[2].toUpperCase();
      var mi = this.fullMonthMap[mn];
      if (mi == null) mi = this.monthMap[mn.substring(0,3)];
      if (mi != null) return Date.UTC(y2, mi, d2);
    }
    return null;
  }

  private getTestTimestamp(t: any): number {
    var td = this.parseDateString((t && t.test_date) || '');
    if (td != null) return td;
    var tn = this.parseDateString((t && t.test_name) || '');
    if (tn != null) return tn;
    return Number.NaN;
  }

  private sortLatestUpcomingFirst(list: any[]): any[] {
    var now = Date.now();
    var future: any[] = [], past: any[] = [], unknown: any[] = [];
    for (var i = 0; i < list.length; i++) {
      var ts = this.getTestTimestamp(list[i]);
      if (isNaN(ts)) { unknown.push(list[i]); }
      else if (ts >= now) { future.push({ ts: ts, item: list[i] }); }
      else { past.push({ ts: ts, item: list[i] }); }
    }
    future.sort(function(a: any, b: any) { return a.ts - b.ts; });
    past.sort(function(a: any, b: any) { return b.ts - a.ts; });
    var out: any[] = [];
    for (var f = 0; f < future.length; f++) out.push(future[f].item);
    for (var p = 0; p < past.length; p++) out.push(past[p].item);
    return out.concat(unknown);
  }

  // ── Client-side filtering (applied to allResults) ──────────
  private applyClientFilters() {
    var self = this;
    var filtered = this.allResults.slice().filter(function(t: any) { return self.isElevenPlus(t); });

    if (this.filters && this.filters.categoryId != null) {
      var cid = Number(this.filters.categoryId);
      var MOCK_IDS   = [16, 28, 29, 30, 31, 32, 33];
      var TOPIC_IDS  = [19];
      var SPRINT_IDS = [39];
      filtered = filtered.filter(function(t: any) {
        var tid  = Number(t.category_id);
        var name = ((t.test_name || '') + '').toLowerCase();
        var cat  = ((t.category  || '') + '').toLowerCase();
        if (cid === 16) return MOCK_IDS.indexOf(tid) !== -1 || name.indexOf('mock')   !== -1 || cat.indexOf('mock')   !== -1;
        if (cid === 19) return TOPIC_IDS.indexOf(tid) !== -1  || name.indexOf('topic')  !== -1 || cat.indexOf('topic')  !== -1;
        if (cid === 39) return SPRINT_IDS.indexOf(tid) !== -1 || name.indexOf('sprint') !== -1 || cat.indexOf('sprint') !== -1;
        return tid === cid;
      });
    }

    if (this.filters && this.filters.pattern != null) {
      var patternMeta  = this.patternTypes.filter(function(p: any) { return String(p.type_id) === String(self.filters.pattern); })[0];
      var patternLabel = patternMeta ? (patternMeta.type || '').toLowerCase() : '';
      if (patternLabel) {
        filtered = filtered.filter(function(t: any) {
          return ((t.type || '') + '').toLowerCase().indexOf(patternLabel) !== -1 ||
                 ((t.test_name || '') + '').toLowerCase().indexOf(patternLabel) !== -1;
        });
      }
    }

    if (this.filters && this.filters.mode && this.filters.mode !== 'Both') {
      var modeVal = (this.filters.mode || '').toLowerCase();
      filtered = filtered.filter(function(t: any) {
        return ((t.exam_type || '') + '').toLowerCase().indexOf(modeVal) !== -1;
      });
    }

    if (this.filters && this.filters.month) {
      var mn = Number(this.filters.month);
      filtered = filtered.filter(function(t: any) { return self.itemInMonth(t, mn); });
    }

    if (this.filters && this.filters.center && this.filters.center !== 'Any') {
      var cn = (this.filters.center || '').toLowerCase();
      filtered = filtered.filter(function(t: any) {
        return ((t.all_location || t.location || '') + '').toLowerCase().indexOf(cn) !== -1;
      });
    }

    if (this.filters && this.filters.search) {
      var q = (this.filters.search + '').toLowerCase().trim();
      if (q) {
        filtered = filtered.filter(function(t: any) {
          return ((t.test_name || '') + '').toLowerCase().indexOf(q) !== -1 ||
                 ((t.all_location || t.location || '') + '').toLowerCase().indexOf(q) !== -1 ||
                 ((t.course || '') + '').toLowerCase().indexOf(q) !== -1 ||
                 ((t.category || '') + '').toLowerCase().indexOf(q) !== -1 ||
                 ((t.type || '') + '').toLowerCase().indexOf(q) !== -1;
        });
      }
    }

    this.testList = this.sortLatestUpcomingFirst(filtered);
    this.centers  = this.buildCenters(this.allResults);

    $('.load-button').css('display', 'none');
    $('.loader-bg').fadeOut();
    this.ref.detectChanges();
  }

  loadMore(append: boolean) { this.applyClientFilters(); }

  // ── Pattern matching helper ────────────────────────────────
  private itemMatchesPattern(t: any, tid: string): boolean {
    var meta = this.patternTypes.filter(function(x: any) { return String(x.type_id) === tid; })[0];
    if (!meta) return true;
    var label = (meta.type || '').toString().toUpperCase();
    var name  = ((t && t.test_name) || '').toString().toUpperCase();
    var ALIASES: any = {
      'GL': [/\bGL\b/,/\bGL[-_]/,/\bGL[A-Z]{2}\d*/],
      'CEM': [/\bCEM\b/], 'CSSE': [/\bCSSE\b/], 'FSCE': [/\bFSCE\b/], 'SET': [/\bSET\b/],
      'GL REDBRIDGE': [/\bREDBRIDGE\b/, /\bGLRB\d*\b/], 'GL BEXLEY': [/\bBEXLEY\b/, /\bGLBX\d*\b/],
      'GL KENT': [/\bKENT\b/, /\bGLKE\d*\b/], 'GL BUCKS': [/\bBUCKS\b/, /\bGLBU\d*\b/],
      'GL QE BARNET': [/\bQE\b/, /\bQE\s*BARNET\b/, /\bGLQE\d*\b/], 'GL HBS': [/\bHBS\b/, /\bGLHBS\d*\b/],
    };
    var patterns = ALIASES[label];
    if (patterns && patterns.length) {
      for (var i = 0; i < patterns.length; i++) { if (patterns[i].test(name)) return true; }
      return false;
    }
    var noSpaceLabel = label.replace(/\s+/g, '');
    var noSpaceName  = name.replace(/\s+/g, '');
    return name.indexOf(label) !== -1 || noSpaceName.indexOf(noSpaceLabel) !== -1;
  }

  // ── Month helper ───────────────────────────────────────────
  private itemInMonth(t: any, monthNum: number): boolean {
    var s = ((t && t.test_date) || '').toString().toUpperCase();
    if (!s) return true;
    var monthsShort = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    var monthsLong  = ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER'];
    var idx = monthNum - 1;
    var mm  = (monthNum < 10 ? '0' + monthNum : '' + monthNum);
    return s.indexOf(monthsShort[idx]) !== -1 || s.indexOf(monthsLong[idx]) !== -1 ||
           new RegExp('\\b\\d{4}-' + mm + '-\\d{1,2}\\b').test(s) ||
           new RegExp('\\b\\d{1,2}/' + mm + '/\\d{2,4}\\b').test(s);
  }

  // ── Centre builder ─────────────────────────────────────────
  private buildCenters(list: any[]): string[] {
    var set: any = {};
    for (var i = 0; i < (list || []).length; i++) {
      var v = ((list[i].all_location || list[i].location || '') + '').trim();
      if (v) set[v] = true;
    }
    var out: string[] = [];
    for (var k in set) { out.push(k); }
    out.sort();
    return out;
  }

  // ── Template helpers ───────────────────────────────────────
  trimChar(str: string, length: number) {
    if (!str) return '';
    var lim = length || 30;
    return str.length < lim ? str : str.substring(0, lim) + '...';
  }

  // ── Date display helpers ───────────────────────────────────
  // Returns true if we can parse a real date from the string
  hasDate(dateStr: string): boolean {
    if (!dateStr) return false;
    return this.parseDateString(dateStr) != null;
  }

  private getDateObj(dateStr: string): Date | null {
    if (!dateStr) return null;
    var ts = this.parseDateString(dateStr);
    return ts != null ? new Date(ts) : null;
  }

  getDateDay(dateStr: string): string {
    var d = this.getDateObj(dateStr);
    return d ? String(d.getUTCDate()) : '';
  }

  getDateMon(dateStr: string): string {
    var d = this.getDateObj(dateStr);
    if (!d) return '';
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[d.getUTCMonth()];
  }

  getDateYr(dateStr: string): string {
    var d = this.getDateObj(dateStr);
    return d ? String(d.getUTCFullYear()) : '';
  }

  isRangeDate(dateStr: string): boolean {
    if (!dateStr) return false;
    return /^(from\s+)/i.test(dateStr.trim());
  }

  toggleFaq(i: number) {
    this.openFaq = this.openFaq === i ? -1 : i;
  }

  // ── Navigation helpers ─────────────────────────────────────
  scrollToCalendar() {
    var el = document.getElementById('calendar-section');
    if (el) { el.scrollIntoView({ behavior: 'smooth' }); }
  }

  scrrollToOffer() {
    var el = document.getElementById('offer-section');
    if (el) { el.scrollIntoView({ behavior: 'smooth' }); }
  }

  downloadCalendar() {
    window.location.href = 'https://drive.google.com/uc?export=download&id=17IdrVz0o3m2Uv6-zT4rdRP6jKRHb2C5-';
  }

  downloadsprint() {
    window.location.href = 'https://drive.google.com/uc?export=download&id=1at2OesLa2qU5T6HPkJIm0bvhbnSgpNZv';
  }

  // ── Legacy DOM location filter ─────────────────────────────
  private locationSpecificList(val: any): void {
    var filter = (val || '').toUpperCase();
    var ul = $('.test-card-listing-body');
    var li = ul.find('.test-card');
    for (var i = 0; i < li.length; i++) {
      var ftestVal   = li[i].getElementsByClassName('f-test-name')[0].textContent || '';
      var fcatVal    = li[i].getElementsByClassName('f-category-name')[0].textContent || '';
      var fcourseVal = li[i].getElementsByClassName('f-course-name')[0].textContent || '';
      var ftypeVal   = li[i].getElementsByClassName('f-type-name')[0].textContent || '';
      var flocVal    = li[i].getElementsByClassName('f-location-name')[0].textContent || '';
      var ffeeVal    = li[i].getElementsByClassName('f-fees')[0].textContent || '';
      if (
        ftestVal.toUpperCase().indexOf(filter) > -1 || fcatVal.toUpperCase().indexOf(filter) > -1 ||
        fcourseVal.toUpperCase().indexOf(filter) > -1 || ftypeVal.toUpperCase().indexOf(filter) > -1 ||
        flocVal.toUpperCase().indexOf(filter) > -1 || ffeeVal.toUpperCase().indexOf(filter) > -1
      ) {
        (li[i] as any).style.display = '';
      } else {
        (li[i] as any).style.display = 'none';
      }
    }
  }
}